// extracted by mini-css-extract-plugin
export default {"menu-container":"toolbar_menu-container__GofFS","left-menu":"toolbar_left-menu__bBLgT","left-menu-label":"toolbar_left-menu-label__36jFv"};